<template>
  <div>
    <!-- 审批流程 -->
    <a-card title="审批流程" :loading="loading" class="card">
      <process :process-list="process" />
    </a-card>
    <!-- 基本类型 -->
    <base-info :baseInfo="baseInfo" :type="type" />
    <!-- 担保申请 -->
    <a-card title="担保申请" style="margin-top:20px;">
      <customize-form-info :infoData="creditInfo"></customize-form-info>
      <!-- 申请原因及备注 -->
      <apply-reason-remark :content="remark || ''" :attachments="attachments" />
    </a-card>
    <!-- 上一级审批意见 -->
    <a-card
      style="margin-top:20px;"
      title="上一级审批意见"
      :loading="loading"
      v-if="approvalList.length"
      class="card"
    >
      <approval-remark-list :approval-list="approvalList" />
    </a-card>
    <!-- 审批意见 显示判断当typeStr===2是为查看 不显示状态为待审批时的审批意见-->
    <a-card
      class="apply-reason-memo"
      title="审批意见"
      style="margin:20px 0;"
      v-if="typeStr !== '2'"
    >
      <quill-editor :token="token" ref="quillEditor"></quill-editor>
    </a-card>
    <!-- 审批意见 显示判断当typeStr===2是为查看 显示审批状态为 审批通过 或 拒绝时 的审批意见-->
    <!-- <Approval-reason-remark :content="remarktwo || ''" /> -->
    <!-- <a-card
      class="apply-reason-memo"
      :title="item.username + `审批意见`"
      style="margin:20px 0;"
    >
      <Approval-reason-remark :content="remarktwo || ''" />
    </a-card> -->

    <!-- 审批 -->
    <footer-tool-bar v-if="typeStr !== '2'">
      <a-button
        type="primary"
        class="margin-right-20"
        @click="handleSubmit(APPROVAL_ACTION_OBJ.PASS)"
        :loading="loading"
      >
        审批通过
      </a-button>
      <a-button
        type="danger"
        class="margin-right-20"
        @click="handleSubmit(APPROVAL_ACTION_OBJ.REJECT)"
        :loading="loading"
      >
        审批不通过
      </a-button>
    </footer-tool-bar>
    <a-modal
      :visible="showvisible"
      @ok="handleShowOk"
      title="提示"
      okText="是"
      @cancel="$router.go(-1)"
    >
      {{ message }}
    </a-modal>
  </div>
</template>

<script>
import BaseInfo from './components/BaseInfo.vue'
import CustomizeFormInfo from './components/CustomizeFormInfo.vue'
import FooterToolBar from 'components/FooterToolBar.vue'
import { queryBase, getAssuranceApply, doApprove } from './api'
import QuillEditor from '../../credit-approval/components/QuillEditor.vue'
import ApplyReasonRemark from './ApplyReasonRemarkView.vue'
// import ApprovalReasonRemark from '../../customer-credit/apply/ApprovalReasonRemarkView.vue'
import { mapGetters } from 'vuex'
import Process from '../../credit-approval/components/Process.vue'
import ApprovalRemarkList from '../../credit-approval/components/ApprovalRemarkList.vue'
import mixin from './mixin'
import { APPLY_REPEAD } from 'config/index'
import moment from 'moment'
const APPROVAL_ACTION_OBJ = {
  PASS: 1,
  REJECT: 2,
}
const guaranteeKeys = [
  'assuranceName',
  'assureNoticeStr',
  'bookTypeStr',
  'code',
  'fileName',
  'identityStr',
  'isListedStr',
  'writtenAmount',
  'validAmount',
  'efficientDate',
  'expireDate',
  'currencyUnitStr',
]
export default {
  name: 'guarantee-approval',
  data() {
    //这里存放数据
    return {
      remarktwo: '',
      process: [], // 审批流程
      APPROVAL_ACTION_OBJ,
      approvalProcessList: [],
      loading: false,
      bpmId: '',
      type: '2',
      remark: '',
      guaranteeKeys,
      companyId: '',
      message: '',
      showvisible: false,
      attachments: {},
      creditInfo: [],
      baseInfo: {},
      guaranteeApplicationData: {},
      actionLoading: false,
    }
  },
  mixins: [mixin],
  components: {
    Process,
    BaseInfo,
    FooterToolBar,
    QuillEditor,
    CustomizeFormInfo,
    ApplyReasonRemark,
    // ApprovalReasonRemark,
    ApprovalRemarkList,
  },

  computed: {
    ...mapGetters('user', ['token']),
    approvalList() {
      const process = this.process
      const list = []
      process.forEach((item, index) => {
        if (index == 0) return
        if (item.approvePerson) {
          list.push({ id: item.id, ...item.approvePerson })
        }
      })
      return list
    },
  },

  //方法集合
  methods: {
    async handleShowOk() {
      this.showvisible = false
      try {
        const query = {
          ack: APPROVAL_ACTION_OBJ.PASS,
          confirmSkip: 1,
          bpmId: this.bpmId,
          remark: this.$refs.quillEditor.getContent(),
        }
        const { code, message } = await doApprove(query)
        if (code == '0000') {
          this.$message.success(message)
          this.$router.push(
            `/client/client-center/detail/guarantee/${this.companyId}`,
          )
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    async handleSubmit(ack) {
      this.loading = true
      try {
        if (ack == APPROVAL_ACTION_OBJ.REJECT) {
          const query = {
            ack,
            bpmId: this.bpmId,
            remark: this.$refs.quillEditor.getContent(),
          }
          const { code, message } = await doApprove(query)
          if (code === '0000') {
            this.$message.success(message)
            this.$router.push(
              `/client/client-center/detail/guarantee/${this.companyId}`,
            )
          }
        } else {
          const query = {
            ack,
            bpmId: this.bpmId,
            remark: this.$refs.quillEditor.getContent(),
          }

          const { code, message } = await doApprove(query)
          if (code == APPLY_REPEAD) {
            this.showvisible = true
            this.message = message
          }
          if (code === '0000') {
            this.$message.success(message)
            this.$router.push(
              `/client/client-center/detail/guarantee/${this.companyId}`,
            )
          }
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    // 提出来function handle keys
    handleKeys(dataObj, targetArr, keysArr) {
      Object.keys(dataObj).forEach(key => {
        if (keysArr.indexOf(key) !== -1) {
          const obj = {}
          obj.key = key
          obj.value = dataObj[key]
          targetArr.push(obj)
        }
      })
      return targetArr
    },
    async getBaseInfo(companyCode) {
      try {
        const { data } = await queryBase(companyCode)
        this.baseInfo = data
      } catch (error) {
        console.log(error)
      }
    },
    async _getAssuranceApply() {
      try {
        const { data } = await getAssuranceApply(this.bpmId)
        this.process = data.process
        this.remarktwo = data.process[1].assigners[0].remark
        if (data.companyAssurance.efficientDate) {
          data.companyAssurance.efficientDate = moment(
            data.companyAssurance.efficientDate,
          ).format('YYYY-MM-DD')
        }
        if (data.companyAssurance.expireDate) {
          data.companyAssurance.expireDate = moment(
            data.companyAssurance.expireDate,
          ).format('YYYY-MM-DD')
        }
        this.filterData(data)
        this.companyId = data.company.id
        this.attachments = data.attachments
        this.remark = data.assuranceBpm.remark
      } catch (error) {
        console.log(error)
      }
    },

    filterData(data) {
      if (data.companyAssurance) {
        const _creditInfo = []
        this.creditInfo = this.handleKeys(
          data.companyAssurance,
          _creditInfo,
          this.guaranteeKeys,
        )
      }
      this.creditInfo.map(item => {
        item.key = mixin.methods.transLabelToName(item.key)
        return item
      })
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.bpmId = this.$route.params.id
    this.companyCode = this.$route.query.companyCode
    this.typeStr = this.$route.query.typeStr
    this.getBaseInfo(this.companyCode)
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this._getAssuranceApply()
  },
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
